import { Helmet } from 'react-helmet-async';
import { useNavigate } from "react-router-dom";
import '../../assets/styles/Marketing.css';
import seoImg from '../../assets/images/seo.jpg';
import socialImg from '../../assets/images/social.jpg';
import emailImg from '../../assets/images/email.jpg';
import contentImg from '../../assets/images/content.jpg';
import influencerImg from '../../assets/images/influencer.jpg';
import analyticsImg from '../../assets/images/analytics.jpg';

const Marketing = () => {
  const navigate = useNavigate();

  const marketingServices = [
    {
      title: "SEO & SEM",
      description: "Boost your visibility through organic and paid search engine marketing strategies.",
      image: seoImg,
      path: "/services/marketing/seo"
    },
    {
      title: "Social Media Marketing",
      description: "Engage your audience and build your brand across top social platforms.",
      image: socialImg,
      path: "/services/marketing/social"
    },
    {
      title: "Email Campaigns",
      description: "Reach your audience with beautifully designed, targeted email campaigns.",
      image: emailImg,
      path: "/services/marketing/email"
    },
    {
      title: "Content Strategy",
      description: "Plan, create and distribute valuable content to attract and retain customers.",
      image: contentImg,
      path: "/services/marketing/content"
    },
    {
      title: "Influencer Marketing",
      description: "Collaborate with trusted voices to authentically promote your brand.",
      image: influencerImg,
      path: "/services/marketing/influencer"
    },
    {
      title: "Analytics & Insights",
      description: "Measure campaign success and make data-driven marketing decisions.",
      image: analyticsImg,
      path: "/services/marketing/analytics"
    }
  ];

  return (
    <>
      <Helmet>
        <title>Marketing Services – BuddyTech Solutions</title>
        <meta name="description" content="Boost brand awareness, traffic and conversions with our expert digital marketing services." />
        <meta name="keywords" content="SEO, social media marketing, email campaigns, content strategy, influencer marketing" />

        <meta property="og:title" content="Marketing Services – BuddyTech Solutions" />
        <meta property="og:description" content="Boost brand awareness, traffic and conversions with our expert digital marketing services." />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/marketing" />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Marketing Services – BuddyTech Solutions" />
        <meta name="twitter:description" content="Boost brand awareness, traffic and conversions with our expert digital marketing services." />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>

      <div className="marketing-container">
        <header className="marketing-hero">
          <h1>Marketing Services</h1>
          <p>Strategic digital marketing to elevate your brand visibility and engagement.</p>
        </header>

        <section className="marketing-services">
          {marketingServices.map((service, index) => (
            <div className="marketing-card" key={index} onClick={() => navigate(service.path)}>
              <img src={service.image} alt={service.title} className="marketing-card-img" />
              <div className="marketing-card-body">
                <h2>{service.title}</h2>
                <p>{service.description}</p>
                <button className="marketing-btn">Explore</button>
              </div>
            </div>
          ))}
        </section>
      </div>
    </>
  );
};

export default Marketing;
